module.exports = __webpack_public_path__ + "static/media/logo_light.4966705f.svg";